import { FaBars } from "react-icons/fa";
import styled from "styled-components";
import { LabelsContainer } from "../common.styles";

interface IAnswerContainerProps {
  isEditing: boolean;
}

export const AnswerContainer = styled(LabelsContainer)<IAnswerContainerProps>`
  display: block;
  padding-top: ${props => (props.isEditing ? 2 : 0)}rem;
`;

export const DragBars = styled(FaBars)`
  cursor: move;
  display: flex;
  align-items: center;
`;
